import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { productBrand } from '../data/offer';
export function GuaranteeSection() {
  return <section className="border-y border-primary/30 bg-surface py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-73" data-mp="9ucr96qafl2n">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-74" data-mp="etz43f27ezax">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-3xl border-2 border-primary bg-background p-8 shadow-2xl shadow-black/40 sm:p-12" data-id="element-75" data-mp="ercvdc3kudr4">
          <span className="inline-flex rounded-full border border-highlight/50 bg-surface p-4 text-highlight" data-id="element-76" data-mp="xk72xkyvf3lb">
            <ShieldCheckIcon className="glow-led h-10 w-10" aria-hidden="true" data-id="element-77" data-mp="12kbk7d7ls2cl" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-3xl font-extrabold uppercase tracking-tight text-foreground sm:text-4xl" data-id="element-78" data-mp="17j6a0z3zmr67">
            7-Day <span className="text-accent" data-id="element-79" data-mp="25puaheui5sin">Guarantee</span>
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-80" data-mp="20s2fgbyk9qa8">
            Study all 6 volumes and 5 bonuses of {productBrand} this week. If the technical depth doesn&apos;t match your
            professional needs,{' '}
            <span className="font-extrabold text-accent" data-id="element-81" data-mp="1ru8qxn71g0xm">we refund 100%. No questions. No complications.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}